import { createAction, props } from '@ngrx/store';
import { LiveUpdateEvent } from 'app/services/live-update.service.types';

export const receiveUpdate = createAction('[Live Updates] Receive Update', props<{ event: LiveUpdateEvent }>());
